package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Sealed class representing actions that can be performed on the whiteboard.
 * Actions are broadcast to all participants in real-time.
 */
@Serializable
sealed class WhiteboardAction {

    /**
     * A stroke drawn on the whiteboard.
     */
    @Serializable
    @SerialName("stroke")
    data class Stroke(
        @SerialName("points")
        val points: List<DrawPoint>,

        @SerialName("color")
        val color: WhiteboardColor,

        @SerialName("stroke_width")
        val strokeWidth: Float
    ) : WhiteboardAction()
    /**
     * Clear all content from the whiteboard.
     */
    @Serializable
    @SerialName("clear")
    data object Clear : WhiteboardAction()

    /**
     * Toggle the grid visibility.
     */
    @Serializable
    @SerialName("toggle_grid")
    data class ToggleGrid(
        @SerialName("show_grid")
        val showGrid: Boolean
    ) : WhiteboardAction()

    /**
     * Close the whiteboard for all participants.
     */
    @Serializable
    @SerialName("close_for_all")
    data object CloseForAll : WhiteboardAction()
}
